// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.select {
  width: 200px;
  margin-top: 20px;
  margin-left: 10px;
  padding-bottom: 5px;
}

.warn {
  width: 200px;
  margin-left: 10px;
  padding-top: 0px;
  margin-bottom: 10px;
  font-size: 11px;
  color: #e30526;
}

.button {
  margin-left: 20px;
  margin-top: 10px;
  width: 175px;
  text-align: center;
}

.mat-icon {
  margin-bottom: 5px;
}

.label {
  margin-top: 10px;
  margin-left: 10px;
  margin-bottom: 10px;
  font-weight: bold;
  font-size: 17px;
}

.table {
  margin: 10px;
}

.table-header {
  font-weight: bold;
  background-color: #f2f2ef;
  color: #3b3b39;
  font-size: 15pt;
  text-align: center;
  margin-top: 2px;
  margin-bottom: 2px;
  padding-bottom: 7px;
  padding-top: 5px;
}

.segment {
  font-weight: bold;
  background-color: #7b7b7b;
  color: #ffffff;
  margin-top: 5px;
  padding-left: 10px;
  padding-bottom: 5px;
  padding-top: 3px;
}

.region {
  font-weight: bold;
  margin-top: 3px;
  padding-left: 15px;
  border-bottom: 1px solid black;
  padding-bottom: 4px;
}

.menu-relative {
  display: flex;
  width: 100%;
}

.header-style {
  font-weight: bold;
  font-size: 15px;
  width: 60px !important;
  text-align: left;
  padding-left: 5px !important;
  padding-right: 5px !important;
}

.mat-mdc-cell {
  width: 10px;
  word-break: break-all;
  border-right: 1px solid #d7d7d7;
  padding-left: 5px !important;
  padding-right: 5px;
  padding-top: 5px;
  padding-bottom: 5px;
  font-size: 13px;
}

tr.mat-mdc-header-row {
  height: 20px !important;
  padding-top: 3px !important;
}

.table-div {
  width: 100%;
  padding-bottom: 20px;
  overflow: hidden;
}

.mat-mdc-row,
.mat-mdc-header-row {
  height: 35px;
  white-space: nowrap;
}

.mat-mdc-table-div {
  overflow: auto;
  max-height: 82vh;
}

.check-mark {
  padding-left: 7px;
}

.message {
  background-color: yellow;
  border: 1px solid black;
  padding: 3px;
  margin-bottom: 15px;
  border-radius: 5px;
  font-weight: bold;
}

.center-year-col {
  text-align: center;
  width: 100%;
}

.vrrFooter {
  bottom: 0px;
  position: static;
  width: 100% !important;
  margin: 0px;
  padding: 0px;
}

:host ::ng-deep .p-multiselect-panel {
  width: 200px;
}

:host ::ng-deep .p-select {
  width: 200px;
}

:host ::ng-deep .p-datatable-header {
  background-color: #f2f2ef;
  font-size: 25px;
  text-align: center;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbInZlaGljbGUtdmVyc2lvbi1yZXBvcnQuY29tcG9uZW50LnNjc3MiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQ0U7RUFDRSxZQUFBO0VBQ0EsZ0JBQUE7RUFDQSxpQkFBQTtFQUNBLG1CQUFBO0FBQUo7O0FBR0U7RUFDRSxZQUFBO0VBQ0EsaUJBQUE7RUFDQSxnQkFBQTtFQUNBLG1CQUFBO0VBQ0EsZUFBQTtFQUNBLGNBQUE7QUFBSjs7QUFHRTtFQUNFLGlCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxZQUFBO0VBQ0Esa0JBQUE7QUFBSjs7QUFHRTtFQUNFLGtCQUFBO0FBQUo7O0FBR0U7RUFDRSxnQkFBQTtFQUNBLGlCQUFBO0VBQ0EsbUJBQUE7RUFDQSxpQkFBQTtFQUNBLGVBQUE7QUFBSjs7QUFHRTtFQUNFLFlBQUE7QUFBSjs7QUFHRTtFQUNFLGlCQUFBO0VBQ0EseUJBQUE7RUFDQSxjQUFBO0VBQ0EsZUFBQTtFQUNBLGtCQUFBO0VBQ0EsZUFBQTtFQUNBLGtCQUFBO0VBQ0EsbUJBQUE7RUFDQSxnQkFBQTtBQUFKOztBQUdFO0VBQ0UsaUJBQUE7RUFDQSx5QkFBQTtFQUNBLGNBQUE7RUFDQSxlQUFBO0VBQ0Esa0JBQUE7RUFDQSxtQkFBQTtFQUNBLGdCQUFBO0FBQUo7O0FBR0U7RUFDRSxpQkFBQTtFQUNBLGVBQUE7RUFDQSxrQkFBQTtFQUNBLDhCQUFBO0VBQ0EsbUJBQUE7QUFBSjs7QUFHRTtFQUNFLGFBQUE7RUFDQSxXQUFBO0FBQUo7O0FBR0U7RUFDRSxpQkFBQTtFQUNBLGVBQUE7RUFDQSxzQkFBQTtFQUNBLGdCQUFBO0VBQ0EsNEJBQUE7RUFDQSw2QkFBQTtBQUFKOztBQUdFO0VBQ0UsV0FBQTtFQUNBLHFCQUFBO0VBQ0EsK0JBQUE7RUFDQSw0QkFBQTtFQUNBLGtCQUFBO0VBQ0EsZ0JBQUE7RUFDQSxtQkFBQTtFQUNBLGVBQUE7QUFBSjs7QUFHRTtFQUNFLHVCQUFBO0VBQ0EsMkJBQUE7QUFBSjs7QUFHRTtFQUNFLFdBQUE7RUFDQSxvQkFBQTtFQUNBLGdCQUFBO0FBQUo7O0FBR0U7O0VBRUUsWUFBQTtFQUNBLG1CQUFBO0FBQUo7O0FBR0U7RUFDRSxjQUFBO0VBQ0EsZ0JBQUE7QUFBSjs7QUFHRTtFQUNFLGlCQUFBO0FBQUo7O0FBR0U7RUFDRSx3QkFBQTtFQUNBLHVCQUFBO0VBQ0EsWUFBQTtFQUNBLG1CQUFBO0VBQ0Esa0JBQUE7RUFDQSxpQkFBQTtBQUFKOztBQUdFO0VBQ0Usa0JBQUE7RUFDQSxXQUFBO0FBQUo7O0FBR0U7RUFDRSxXQUFBO0VBQ0EsZ0JBQUE7RUFDQSxzQkFBQTtFQUNBLFdBQUE7RUFDQSxZQUFBO0FBQUo7O0FBR0U7RUFDRSxZQUFBO0FBQUo7O0FBRUU7RUFDRSxZQUFBO0FBQ0o7O0FBQ0U7RUFDRSx5QkFBQTtFQUNBLGVBQUE7RUFDQSxrQkFBQTtBQUVKIiwiZmlsZSI6InZlaGljbGUtdmVyc2lvbi1yZXBvcnQuY29tcG9uZW50LnNjc3MiLCJzb3VyY2VzQ29udGVudCI6WyJcbiAgLnNlbGVjdCB7XG4gICAgd2lkdGg6IDIwMHB4O1xuICAgIG1hcmdpbi10b3A6IDIwcHg7XG4gICAgbWFyZ2luLWxlZnQ6IDEwcHg7XG4gICAgcGFkZGluZy1ib3R0b206IDVweDtcbiAgfVxuICBcbiAgLndhcm4ge1xuICAgIHdpZHRoOiAyMDBweDtcbiAgICBtYXJnaW4tbGVmdDogMTBweDtcbiAgICBwYWRkaW5nLXRvcDogMHB4O1xuICAgIG1hcmdpbi1ib3R0b206IDEwcHg7XG4gICAgZm9udC1zaXplOiAxMXB4O1xuICAgIGNvbG9yOiAjZTMwNTI2O1xuICB9XG4gIFxuICAuYnV0dG9uIHtcbiAgICBtYXJnaW4tbGVmdDogMjBweDtcbiAgICBtYXJnaW4tdG9wOiAxMHB4O1xuICAgIHdpZHRoOiAxNzVweDtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gIH1cbiAgXG4gIC5tYXQtaWNvbiB7XG4gICAgbWFyZ2luLWJvdHRvbTogNXB4O1xuICB9XG4gIFxuICAubGFiZWwge1xuICAgIG1hcmdpbi10b3A6IDEwcHg7XG4gICAgbWFyZ2luLWxlZnQ6IDEwcHg7XG4gICAgbWFyZ2luLWJvdHRvbTogMTBweDtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICBmb250LXNpemU6IDE3cHg7XG4gIH1cbiAgXG4gIC50YWJsZSB7XG4gICAgbWFyZ2luOiAxMHB4O1xuICB9XG4gIFxuICAudGFibGUtaGVhZGVyIHtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjZjJmMmVmO1xuICAgIGNvbG9yOiAjM2IzYjM5O1xuICAgIGZvbnQtc2l6ZTogMTVwdDtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgbWFyZ2luLXRvcDogMnB4O1xuICAgIG1hcmdpbi1ib3R0b206IDJweDtcbiAgICBwYWRkaW5nLWJvdHRvbTogN3B4O1xuICAgIHBhZGRpbmctdG9wOiA1cHg7XG4gIH1cbiAgXG4gIC5zZWdtZW50IHtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiAjN2I3YjdiO1xuICAgIGNvbG9yOiAjZmZmZmZmO1xuICAgIG1hcmdpbi10b3A6IDVweDtcbiAgICBwYWRkaW5nLWxlZnQ6IDEwcHg7XG4gICAgcGFkZGluZy1ib3R0b206IDVweDtcbiAgICBwYWRkaW5nLXRvcDogM3B4O1xuICB9XG4gIFxuICAucmVnaW9uIHtcbiAgICBmb250LXdlaWdodDogYm9sZDtcbiAgICBtYXJnaW4tdG9wOiAzcHg7XG4gICAgcGFkZGluZy1sZWZ0OiAxNXB4O1xuICAgIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCBibGFjaztcbiAgICBwYWRkaW5nLWJvdHRvbTogNHB4O1xuICB9XG4gIFxuICAubWVudS1yZWxhdGl2ZSB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICB3aWR0aDogMTAwJTtcbiAgfVxuICBcbiAgLmhlYWRlci1zdHlsZSB7XG4gICAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gICAgZm9udC1zaXplOiAxNXB4O1xuICAgIHdpZHRoOiA2MHB4ICFpbXBvcnRhbnQ7XG4gICAgdGV4dC1hbGlnbjogbGVmdDtcbiAgICBwYWRkaW5nLWxlZnQ6IDVweCAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctcmlnaHQ6IDVweCAhaW1wb3J0YW50O1xuICB9XG4gIFxuICAubWF0LW1kYy1jZWxsIHtcbiAgICB3aWR0aDogMTBweDtcbiAgICB3b3JkLWJyZWFrOiBicmVhay1hbGw7XG4gICAgYm9yZGVyLXJpZ2h0OiAxcHggc29saWQgI2Q3ZDdkNztcbiAgICBwYWRkaW5nLWxlZnQ6IDVweCAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctcmlnaHQ6IDVweDtcbiAgICBwYWRkaW5nLXRvcDogNXB4O1xuICAgIHBhZGRpbmctYm90dG9tOiA1cHg7XG4gICAgZm9udC1zaXplOiAxM3B4O1xuICB9XG4gIFxuICB0ci5tYXQtbWRjLWhlYWRlci1yb3cge1xuICAgIGhlaWdodDogMjBweCAhaW1wb3J0YW50O1xuICAgIHBhZGRpbmctdG9wOiAzcHggIWltcG9ydGFudDtcbiAgfVxuICBcbiAgLnRhYmxlLWRpdiB7XG4gICAgd2lkdGg6IDEwMCU7XG4gICAgcGFkZGluZy1ib3R0b206IDIwcHg7XG4gICAgb3ZlcmZsb3c6IGhpZGRlbjtcbiAgfVxuICBcbiAgLm1hdC1tZGMtcm93LFxuICAubWF0LW1kYy1oZWFkZXItcm93IHtcbiAgICBoZWlnaHQ6IDM1cHg7XG4gICAgd2hpdGUtc3BhY2U6IG5vd3JhcDtcbiAgfVxuICBcbiAgLm1hdC1tZGMtdGFibGUtZGl2IHtcbiAgICBvdmVyZmxvdzogYXV0bztcbiAgICBtYXgtaGVpZ2h0OiA4MnZoO1xuICB9XG4gIFxuICAuY2hlY2stbWFyayB7XG4gICAgcGFkZGluZy1sZWZ0OiA3cHg7XG4gIH1cbiAgXG4gIC5tZXNzYWdlIHtcbiAgICBiYWNrZ3JvdW5kLWNvbG9yOiB5ZWxsb3c7XG4gICAgYm9yZGVyOiAxcHggc29saWQgYmxhY2s7XG4gICAgcGFkZGluZzogM3B4O1xuICAgIG1hcmdpbi1ib3R0b206IDE1cHg7XG4gICAgYm9yZGVyLXJhZGl1czogNXB4O1xuICAgIGZvbnQtd2VpZ2h0OiBib2xkO1xuICB9XG4gIFxuICAuY2VudGVyLXllYXItY29sIHtcbiAgICB0ZXh0LWFsaWduOiBjZW50ZXI7XG4gICAgd2lkdGg6IDEwMCU7XG4gIH1cbiAgXG4gIC52cnJGb290ZXIge1xuICAgIGJvdHRvbTogMHB4O1xuICAgIHBvc2l0aW9uOiBzdGF0aWM7XG4gICAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcbiAgICBtYXJnaW46IDBweDtcbiAgICBwYWRkaW5nOiAwcHg7XG4gIH1cbiAgXG4gIDpob3N0IDo6bmctZGVlcCAucC1tdWx0aXNlbGVjdC1wYW5lbCB7XG4gICAgd2lkdGg6IDIwMHB4O1xuICB9XG4gIDpob3N0IDo6bmctZGVlcCAucC1zZWxlY3Qge1xuICAgIHdpZHRoOiAyMDBweDtcbiAgfVxuICA6aG9zdCA6Om5nLWRlZXAgLnAtZGF0YXRhYmxlLWhlYWRlciB7XG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2YyZjJlZjtcbiAgICBmb250LXNpemU6IDI1cHg7XG4gICAgdGV4dC1hbGlnbjogY2VudGVyO1xuICB9Il19 */`, "",{"version":3,"sources":["webpack://./src/app/components/reports/vehicle-version-report/vehicle-version-report.component.scss"],"names":[],"mappings":"AACE;EACE,YAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;AAAJ;;AAGE;EACE,YAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AAAJ;;AAGE;EACE,iBAAA;EACA,gBAAA;EACA,YAAA;EACA,kBAAA;AAAJ;;AAGE;EACE,kBAAA;AAAJ;;AAGE;EACE,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;AAAJ;;AAGE;EACE,YAAA;AAAJ;;AAGE;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,iBAAA;EACA,yBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,iBAAA;EACA,eAAA;EACA,kBAAA;EACA,8BAAA;EACA,mBAAA;AAAJ;;AAGE;EACE,aAAA;EACA,WAAA;AAAJ;;AAGE;EACE,iBAAA;EACA,eAAA;EACA,sBAAA;EACA,gBAAA;EACA,4BAAA;EACA,6BAAA;AAAJ;;AAGE;EACE,WAAA;EACA,qBAAA;EACA,+BAAA;EACA,4BAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,eAAA;AAAJ;;AAGE;EACE,uBAAA;EACA,2BAAA;AAAJ;;AAGE;EACE,WAAA;EACA,oBAAA;EACA,gBAAA;AAAJ;;AAGE;;EAEE,YAAA;EACA,mBAAA;AAAJ;;AAGE;EACE,cAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,iBAAA;AAAJ;;AAGE;EACE,wBAAA;EACA,uBAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,iBAAA;AAAJ;;AAGE;EACE,kBAAA;EACA,WAAA;AAAJ;;AAGE;EACE,WAAA;EACA,gBAAA;EACA,sBAAA;EACA,WAAA;EACA,YAAA;AAAJ;;AAGE;EACE,YAAA;AAAJ;;AAEE;EACE,YAAA;AACJ;;AACE;EACE,yBAAA;EACA,eAAA;EACA,kBAAA;AAEJ;AACA,o4KAAo4K","sourcesContent":["\n  .select {\n    width: 200px;\n    margin-top: 20px;\n    margin-left: 10px;\n    padding-bottom: 5px;\n  }\n  \n  .warn {\n    width: 200px;\n    margin-left: 10px;\n    padding-top: 0px;\n    margin-bottom: 10px;\n    font-size: 11px;\n    color: #e30526;\n  }\n  \n  .button {\n    margin-left: 20px;\n    margin-top: 10px;\n    width: 175px;\n    text-align: center;\n  }\n  \n  .mat-icon {\n    margin-bottom: 5px;\n  }\n  \n  .label {\n    margin-top: 10px;\n    margin-left: 10px;\n    margin-bottom: 10px;\n    font-weight: bold;\n    font-size: 17px;\n  }\n  \n  .table {\n    margin: 10px;\n  }\n  \n  .table-header {\n    font-weight: bold;\n    background-color: #f2f2ef;\n    color: #3b3b39;\n    font-size: 15pt;\n    text-align: center;\n    margin-top: 2px;\n    margin-bottom: 2px;\n    padding-bottom: 7px;\n    padding-top: 5px;\n  }\n  \n  .segment {\n    font-weight: bold;\n    background-color: #7b7b7b;\n    color: #ffffff;\n    margin-top: 5px;\n    padding-left: 10px;\n    padding-bottom: 5px;\n    padding-top: 3px;\n  }\n  \n  .region {\n    font-weight: bold;\n    margin-top: 3px;\n    padding-left: 15px;\n    border-bottom: 1px solid black;\n    padding-bottom: 4px;\n  }\n  \n  .menu-relative {\n    display: flex;\n    width: 100%;\n  }\n  \n  .header-style {\n    font-weight: bold;\n    font-size: 15px;\n    width: 60px !important;\n    text-align: left;\n    padding-left: 5px !important;\n    padding-right: 5px !important;\n  }\n  \n  .mat-mdc-cell {\n    width: 10px;\n    word-break: break-all;\n    border-right: 1px solid #d7d7d7;\n    padding-left: 5px !important;\n    padding-right: 5px;\n    padding-top: 5px;\n    padding-bottom: 5px;\n    font-size: 13px;\n  }\n  \n  tr.mat-mdc-header-row {\n    height: 20px !important;\n    padding-top: 3px !important;\n  }\n  \n  .table-div {\n    width: 100%;\n    padding-bottom: 20px;\n    overflow: hidden;\n  }\n  \n  .mat-mdc-row,\n  .mat-mdc-header-row {\n    height: 35px;\n    white-space: nowrap;\n  }\n  \n  .mat-mdc-table-div {\n    overflow: auto;\n    max-height: 82vh;\n  }\n  \n  .check-mark {\n    padding-left: 7px;\n  }\n  \n  .message {\n    background-color: yellow;\n    border: 1px solid black;\n    padding: 3px;\n    margin-bottom: 15px;\n    border-radius: 5px;\n    font-weight: bold;\n  }\n  \n  .center-year-col {\n    text-align: center;\n    width: 100%;\n  }\n  \n  .vrrFooter {\n    bottom: 0px;\n    position: static;\n    width: 100% !important;\n    margin: 0px;\n    padding: 0px;\n  }\n  \n  :host ::ng-deep .p-multiselect-panel {\n    width: 200px;\n  }\n  :host ::ng-deep .p-select {\n    width: 200px;\n  }\n  :host ::ng-deep .p-datatable-header {\n    background-color: #f2f2ef;\n    font-size: 25px;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
